@if (isLoading$ | async) {
  <div class="page-nav-loading">
    <img class='h4-medium' aria-live="assertive" src="assets/images/loader-dark.gif" aria-label="Loading..." alt="Loading...">
    {{ waitMessage }}
  </div>
}
